import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from '@fs/zion-router'
import { usePageView } from '@fs/zion-analytics'
import SubnavAndRoutes from '../app/SubnavAndRoutes'
import Request from '../request/Request'
import TempleInventory from './inventory/TempleInventory'
import PrintableInventoryName from './inventory-info/PrintableInventoryName'
import TempleKiosks from './kiosks/TempleKiosks'
import MetaData from '../metadata/MetaData'
import CtrBase from '../ctr/CtrBase'
import OwsBase from '../ows/OwsBase'
import { usePageTitle } from '../app/PageTitleContext'

export default function TempleBase() {
  usePageView({ page_detail: 'DMConsole:TempleBase' })
  const { t } = useTranslation()
  usePageTitle(t('pageTitle.temple.base'))
  const [templeMetadata, setTempleMetadata] = useState()
  const { pathname } = useLocation()
  const pinId = pathname?.split('/inventory-info/')?.[1]?.split('/')?.[0]
  useEffect(() => {
    // Only show metadata if on inventory-info/:pinId
    if (!/\/inventory-info\/[\w-]+(\/|$)/.test(pathname || '')) {
      setTempleMetadata(null)
    } else {
      const metadataHeader = t('temple.subnav.inventoryInfo', 'Inventory Info')
      const items = [
        {
          value: { value: pinId },
          label: t('pinId', 'PIN ID'),
          showLabel: true,
          field: 'pinId',
        },
      ]
      setTempleMetadata({ header: metadataHeader, items, badges: null })
    }
  }, [pathname, pinId, t])

  const subNavs = [
    {
      text: t('temple.subnav.inventory', 'Inventory'),
      path: 'inventory',
      requiredPermissions: [
        'tss_ReadTempleProfilePermission',
        'tss_UpdateTempleProfilePermission',
        'tss_CreateTempleProfilePermission',
      ],
      component: TempleInventory,
    },
    {
      path: 'inventory-info/:pinId',
      requiredPermissions: ['tss_ReadInventoryItemPermission'],
      component: PrintableInventoryName,
    },
    {
      text: t('temple.subnav.inventoryInfo', 'Inventory Info'),
      path: 'inventory-info',
      requiredPermissions: ['tss_ReadInventoryItemPermission'],
      component: PrintableInventoryName,
    },
    {
      path: 'ctr/:ctrId',
      requiredPermissions: ['tss_ReadCtrControlledPermission', 'tss_ReadCtrFullAcdPermission'],
      component: CtrBase,
    },
    {
      text: t('ctr.label', 'CTR'),
      path: 'ctr',
      requiredPermissions: ['tss_ReadCtrControlledPermission', 'tss_ReadCtrFullAcdPermission'],
      component: CtrBase,
    },
    {
      path: 'ows/:owsId',
      requiredPermissions: 'tss_ReadOwsPermission',
      component: OwsBase,
    },
    {
      text: t('temple.subnav.ows', 'OWS'),
      path: 'ows',
      requiredPermissions: 'tss_ReadOwsPermission',
      component: OwsBase,
    },
    {
      path: 'request/:requestId',
      requiredPermissions: ['tss_ReadLorPermission', 'tss_ReadForPermission', 'tss_ReadTempleListPermission'],
      component: Request,
    },
    {
      text: t('request', 'Request'),
      path: 'request',
      requiredPermissions: ['tss_ReadLorPermission', 'tss_ReadForPermission', 'tss_ReadTempleListPermission'],
      component: Request,
    },
    {
      text: t('kiosks', 'Kiosks'),
      path: 'kiosks',
      requiredPermissions: [
        'tss_ReadKioskPermission',
        'tss_ModifyKioskPermission',
        'tss_DeleteKioskPermission',
        'tss_CreateKioskPermission',
      ],
      component: TempleKiosks,
    },
  ]

  return (
    <>
      <MetaData metadata={templeMetadata} />
      <SubnavAndRoutes data={subNavs} defaultPath="inventory" />
    </>
  )
}
